@if (editMode()) {
	<div class="autocomplete-contact-container">
		<mat-form-field
			[ngClass]="namePreviewClasses()"
			class="no-label au-header-input width-100"
		>
			<mat-autocomplete
				#auto="matAutocomplete"
				hideSingleSelectionIndicator
				panelWidth="600px"
				class="nice-scroll colored-scroll-track"
			>
				@for (group of contactGroup(); track group.name) {
					@if (
						group.contacts
							| auQuickSearchName: formControl.value : ['firstName', 'lastName', 'email'];
						as filteredContacts
					) {
						@if (filteredContacts.length > 0) {
							<mat-optgroup [label]="group.name" class="opt-group">
								@for (contact of filteredContacts; track contact.id) {
									@if (contact.email) {
										<mat-option [value]="contact" (mousedown)="$event.preventDefault()">
											<span class="black-text"
												>{{ contact.firstName }} {{ contact.lastName }} ({{
													contact.email
												}})
											</span></mat-option
										>
									}
								}
							</mat-optgroup>
						}
					}
				}
			</mat-autocomplete>
			<input
				#trigger="matAutocompleteTrigger"
				matInput
				type="text"
				class="no-label au-header-input width-100"
				[formControl]="formControl"
				[placeholder]="placeholder()"
				[matAutocomplete]="auto"
				(keydown.enter)="requesteeChanged()"
				(blur)="requesteeChanged()"
			/>
		</mat-form-field>
	</div>
} @else {
	<div div class="show-requestees">
		@for (requestee of requestees(); track requestee.email) {
			@if (requestee?.email) {
				<span class="contact">{{ requestee.email }}</span>
			}
		}
		@if (!autoGenerated() && allowEdit()) {
			<button
				mat-fab
				class="round-button mat-fab--p0 au-button-no-shadow"
				(click)="editMode.set(true)"
			>
				<mat-icon [svgIcon]="hasValidValue() ? 'edit' : 'add'"></mat-icon>
			</button>
		}
	</div>
}
